(function () {
  if (window.__cartLineUpsellBound) return;
  window.__cartLineUpsellBound = true;

  var routes = window.routes || {};
  var CART_CHANGE_URL = routes.cart_change_url || '/cart/change';
  var CART_ADD_URL = routes.cart_add_url || '/cart/add';

  function toJsonUrl(url) {
    return url.endsWith('.js') ? url : url + '.js';
  }

  function refreshCartUI() {
    if (typeof window.refreshVoltaCartUI === 'function') {
      return window.refreshVoltaCartUI();
    }

    window.location.reload();
    return Promise.resolve();
  }

  async function postCart(url, body) {
    var response = await window.fetch(toJsonUrl(url), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async function subscribeLine(button) {
    var lineKey = button.getAttribute('data-line-key');
    var sellingPlan = button.getAttribute('data-selling-plan');
    if (!lineKey || !sellingPlan) return;

    var cartItem = button.closest('cart-item');
    var quantity = cartItem ? Number(cartItem.getAttribute('data-quantity')) : null;

    button.disabled = true;

    var body = {
      id: lineKey,
      selling_plan: Number(sellingPlan)
    };

    if (quantity > 0) {
      body.quantity = quantity;
    }

    try {
      await postCart(CART_CHANGE_URL, body);
      await settleCartAfterMutation();
    } catch (error) {
      console.warn(error);
      button.disabled = false;
    }
  }

  async function upgradeLine(button) {
    var lineKey = button.getAttribute('data-line-key');
    var variantId = Number(button.getAttribute('data-variant-id'));
    var quantity = Number(button.getAttribute('data-quantity')) || 1;
    var voltaUnits = Number(button.getAttribute('data-volta-units')) || 0;
    if (!lineKey || !variantId) return;

    button.disabled = true;

    var addBody = {
      items: [
        {
          id: variantId,
          quantity: quantity
        }
      ]
    };

    if (voltaUnits > 0) {
      addBody.items[0].properties = {
        _volta_units: String(voltaUnits)
      };
    }

    try {
      await postCart(CART_ADD_URL, addBody);
      await postCart(CART_CHANGE_URL, {
        id: lineKey,
        quantity: 0
      });
      await settleCartAfterMutation();
    } catch (error) {
      console.warn(error);
      button.disabled = false;
    }
  }

  document.addEventListener('click', function (event) {
    var upgradeButton = event.target.closest('[data-pack-upgrade]');
    if (upgradeButton && !upgradeButton.disabled) {
      event.preventDefault();
      upgradeLine(upgradeButton);
      return;
    }

    var subscribeButton = event.target.closest('[data-subscribe-upsell]');
    if (subscribeButton && !subscribeButton.disabled) {
      event.preventDefault();
      subscribeLine(subscribeButton);
      return;
    }

    var completerButton = event.target.closest('[data-pack-completer-add]');
    if (completerButton && !completerButton.disabled) {
      event.preventDefault();
      addCompleterPack(completerButton);
    }
  });

  document.addEventListener('change', function (event) {
    var option = event.target.closest('[data-pack-completer-option]');
    if (!option) return;

    var root = option.closest('[data-pack-completer]');
    if (!root) return;

    var button = root.querySelector('[data-pack-completer-add]');
    if (!button) return;

    button.setAttribute('data-variant-id', option.value);
    button.setAttribute('data-volta-units', option.getAttribute('data-volta-units') || '0');
  });

  var sliderDrag = null;
  var sliderJustDragged = false;
  var sliderCheckedRadio = null;
  var scrollbarFrame = null;
  var scrollbarDrag = null;

  function updateSliderScrollbar(slider) {
    var wrap = slider.closest('.cart-pack-completer__slider-wrap');
    if (!wrap) return;

    var track = wrap.querySelector('[data-pack-completer-scrollbar]');
    if (!track) return;

    var overflow = slider.scrollWidth - slider.clientWidth;
    if (overflow <= 1) {
      wrap.classList.add('is-not-scrollable');
      return;
    }

    wrap.classList.remove('is-not-scrollable');

    var visibleRatio = slider.clientWidth / slider.scrollWidth;
    var thumbSize = Math.max(visibleRatio * 100, 12);
    var progress = Math.min(Math.max(slider.scrollLeft / overflow, 0), 1);

    track.style.setProperty('--pack-thumb-size', thumbSize + '%');
    track.style.setProperty('--pack-thumb-offset', progress * (100 - thumbSize) + '%');
  }

  function updateAllSliderScrollbars() {
    var sliders = document.querySelectorAll('[data-pack-completer-slider]');
    if (!sliders.length) return;
    sliders.forEach(updateSliderScrollbar);
  }

  function scheduleScrollbarUpdate() {
    if (scrollbarFrame) return;
    scrollbarFrame = window.requestAnimationFrame(function () {
      scrollbarFrame = null;
      updateAllSliderScrollbars();
    });
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var slider = event.target;
      if (!slider || !slider.matches || !slider.matches('[data-pack-completer-slider]')) return;
      updateSliderScrollbar(slider);
    },
    true
  );

  window.addEventListener('resize', scheduleScrollbarUpdate);
  new MutationObserver(scheduleScrollbarUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  scheduleScrollbarUpdate();

  function readScrollbarMetrics(track) {
    var wrap = track.closest('.cart-pack-completer__slider-wrap');
    var slider = wrap && wrap.querySelector('[data-pack-completer-slider]');
    if (!slider) return null;

    var overflow = slider.scrollWidth - slider.clientWidth;
    if (overflow <= 1) return null;

    var thumb = track.querySelector('.cart-pack-completer__scroll-thumb');
    var trackRect = track.getBoundingClientRect();
    var thumbRect = thumb ? thumb.getBoundingClientRect() : null;

    return {
      slider: slider,
      overflow: overflow,
      left: trackRect.left,
      thumbRect: thumbRect,
      maxOffset: Math.max(trackRect.width - (thumbRect ? thumbRect.width : 0), 0)
    };
  }

  function scrollFromScrollbar(metrics, clientX, grabOffset) {
    if (metrics.maxOffset <= 0) return;

    var offset = clientX - metrics.left - grabOffset;
    var progress = Math.min(Math.max(offset / metrics.maxOffset, 0), 1);
    metrics.slider.scrollLeft = progress * metrics.overflow;
  }

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest) return;

    var track = event.target.closest('[data-pack-completer-scrollbar]');
    if (!track) return;

    var metrics = readScrollbarMetrics(track);
    if (!metrics) return;

    var thumbRect = metrics.thumbRect;
    var onThumb = thumbRect && event.clientX >= thumbRect.left && event.clientX <= thumbRect.right;
    var grabOffset = onThumb ? event.clientX - thumbRect.left : (thumbRect ? thumbRect.width : 0) / 2;

    scrollbarDrag = { metrics: metrics, grabOffset: grabOffset, track: track };
    track.classList.add('is-dragging');

    if (!onThumb) {
      scrollFromScrollbar(metrics, event.clientX, grabOffset);
    }

    if (track.setPointerCapture) {
      track.setPointerCapture(event.pointerId);
    }

    event.preventDefault();
  });

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!scrollbarDrag) return;
      scrollFromScrollbar(scrollbarDrag.metrics, event.clientX, scrollbarDrag.grabOffset);
      event.preventDefault();
    },
    { passive: false }
  );

  function endScrollbarDrag() {
    if (!scrollbarDrag) return;
    scrollbarDrag.track.classList.remove('is-dragging');
    scrollbarDrag = null;
  }

  document.addEventListener('pointerup', endScrollbarDrag);
  document.addEventListener('pointercancel', endScrollbarDrag);

  function markSliderDragged(slider) {
    sliderJustDragged = true;
    if (slider) slider.classList.add('is-dragging');
    window.clearTimeout(markSliderDragged.timer);
    markSliderDragged.timer = window.setTimeout(function () {
      sliderJustDragged = false;
      document.querySelectorAll('[data-pack-completer-slider].is-dragging').forEach(function (el) {
        el.classList.remove('is-dragging');
      });
    }, 400);
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var slider = event.target.closest('[data-pack-completer-slider]');
      if (!slider) return;

      sliderDrag = {
        slider: slider,
        startX: event.clientX,
        startScroll: slider.scrollLeft,
        pointerType: event.pointerType,
        moved: false,
        checked: slider.querySelector('[data-pack-completer-option]:checked')
      };
      sliderCheckedRadio = sliderDrag.checked;
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (event) {
      if (!sliderDrag) return;

      var delta = event.clientX - sliderDrag.startX;
      var scrolled = sliderDrag.slider.scrollLeft - sliderDrag.startScroll;
      if (Math.abs(delta) > 8 || Math.abs(scrolled) > 8) {
        sliderDrag.moved = true;
        markSliderDragged(sliderDrag.slider);
      }

      if (sliderDrag.moved && sliderDrag.pointerType !== 'touch') {
        event.preventDefault();
        sliderDrag.slider.scrollLeft = sliderDrag.startScroll - delta;
      }
    },
    { passive: false, capture: true }
  );

  document.addEventListener(
    'scroll',
    function (event) {
      if (!sliderDrag) return;
      if (event.target !== sliderDrag.slider) return;
      if (Math.abs(sliderDrag.slider.scrollLeft - sliderDrag.startScroll) > 8) {
        sliderDrag.moved = true;
        markSliderDragged(sliderDrag.slider);
      }
    },
    true
  );

  function endSliderDrag(event) {
    if (!sliderDrag) return;

    var moved = sliderDrag.moved || Math.abs(sliderDrag.slider.scrollLeft - sliderDrag.startScroll) > 8;
    var slider = sliderDrag.slider;
    sliderDrag = null;

    if (!moved) {
      slider.classList.remove('is-dragging');
      return;
    }

    markSliderDragged(slider);
    if (event) {
      event.preventDefault();
    }
  }

  document.addEventListener('pointerup', endSliderDrag, true);
  document.addEventListener('pointercancel', endSliderDrag, true);

  document.addEventListener(
    'click',
    function (event) {
      if (!sliderJustDragged) return;
      if (!event.target.closest('[data-pack-completer-slider]')) return;
      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!sliderJustDragged) return;
      var option = event.target.closest('[data-pack-completer-option]');
      if (!option) return;
      event.stopImmediatePropagation();
      option.checked = false;
      if (sliderCheckedRadio && sliderCheckedRadio !== option) {
        sliderCheckedRadio.checked = true;
      }
    },
    true
  );

  async function addCompleterPack(button) {
    var variantId = Number(button.getAttribute('data-variant-id'));
    var voltaUnits = Number(button.getAttribute('data-volta-units')) || 0;
    if (!variantId) return;

    button.disabled = true;

    var addBody = {
      items: [
        {
          id: variantId,
          quantity: 1
        }
      ]
    };

    if (voltaUnits > 0) {
      addBody.items[0].properties = {
        _volta_units: String(voltaUnits)
      };
    }

    try {
      await postCart(CART_ADD_URL, addBody);
      var completes = button.getAttribute('data-pack-completes') === 'true';
      if (completes) {
        await new Promise(function (resolve) {
          setTimeout(resolve, 400);
        });
      }
      await settleCartAfterMutation({ skipConvert: !completes });
    } catch (error) {
      console.warn(error);
      if (typeof window.releasePackConversionUI === 'function') {
        window.releasePackConversionUI();
      }
      button.disabled = false;
    }
  }

  async function settleCartAfterMutation(options) {
    var converted = false;
    var skipConvert = options && options.skipConvert;
    if (!skipConvert && typeof window.maybeConvertToCustomPack === 'function') {
      converted = await window.maybeConvertToCustomPack();
    }
    if (converted && typeof window.finishPackConversionUI === 'function') {
      await window.finishPackConversionUI();
      return;
    }
    if (typeof window.syncVoltaDeposit === 'function') {
      await window.syncVoltaDeposit();
    }
    await refreshCartUI();
    if (typeof window.releasePackConversionUI === 'function') {
      window.releasePackConversionUI();
    }
  }
})();
